import { API_BASE_URL as BASE } from '@/lib/apiBase'
import { authFetch, authHeaders } from '@/lib/authFetch'

/**
 * The signed-in person's own activity, for the User audit trail: the pages
 * they open and their sign-out (a sign-in is recorded by the server itself).
 *
 * Best effort by design. Recording must never interrupt the person: a failure
 * is swallowed, and nothing here redirects to sign-in the way the other
 * clients' `handleUnauthorized` does.
 */
export const userActivityApi = {
  /** A page opened. Renews an expired token like any other call. */
  pageView(path: string): void {
    void authFetch(`${BASE}/user-activity`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ eventType: 'page_view', path }),
    }).catch(() => {})
  },

  /**
   * The sign-out. Must be called BEFORE the session is cleared: the headers
   * (token and tenant) are read synchronously here, and `keepalive` lets the
   * request finish while the app moves to the sign-in page. No token renewal —
   * this session is ending.
   */
  logout(): void {
    void fetch(`${BASE}/user-activity`, {
      method: 'POST',
      headers: authHeaders({ 'Content-Type': 'application/json' }),
      body: JSON.stringify({ eventType: 'logout' }),
      keepalive: true,
    }).catch(() => {})
  },
}
